import { render, staticRenderFns } from "./TaskChatRef.vue?vue&type=template&id=3b495f11"
import script from "./TaskChatRef.vue?vue&type=script&lang=js"
export * from "./TaskChatRef.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports